export class Cadastro  {
    nome: string = ""
    ID: string = ""
    senha: string = ""
    confirmacaoSenha: string = ""
    tableName: string = ""
    role: string = ""
    flowsAccess: string = ""
    company: string = ""
}